import React, { useState } from 'react'
import moment from 'moment'
import Date from '../../date/relative'
import JOB_STATES from '../../../constants/job-states'
import JobModal from '../job-modal'

const JobListItem = ({
    job = {},
}) => {
    const {
        id,
        name,
        description,
        updatedDate,
        state,
        rate,
        rateUnit,
        config,
        lastRunDate,
    } = job

    const [ isDetailsVisible, setDetailsVisible] = useState(false)

    let nextRun = ''
    if (rate && rateUnit && state !== JOB_STATES.STARTED) {
        nextRun = moment(lastRunDate).add(rate, rateUnit)
    }

    const invalidLabel = (!rate || !rateUnit) ? 'DISABLED' : ''

    const renderDetails = () => {
        return isDetailsVisible ? (<JobModal job={job} onHide={() => setDetailsVisible(false)} />) : null
    }
    
    return (
        <React.Fragment>
            <tr
                style={{
                    cursor: 'pointer'
                }}
                onClick={() => setDetailsVisible(true)}
            >
                <td>{name}</td>
                <td>{state}</td>
                <td><Date value={lastRunDate} /></td>
                <td><Date value={nextRun} invalidLabel={invalidLabel}/></td>
                
            </tr>
            {renderDetails()}
        </React.Fragment>
    )
}

export default JobListItem